module.exports = __webpack_public_path__ + "h5/img/banner.d4cfe1eb.png";